// Nova API Client for backend integration
import { NovaApiResponse } from "../types/workflow.types";

class NovaApiClient {
  private baseUrl =
    "https://ssynkopscore-production.up.railway.app/api/v1/chat/";

  /**
   * Send a message to Nova API
   * @param message - The user message
   * @param threadId - Optional thread ID for context continuation
   * @param attachedFile - Optional file attachment
   */
  async sendMessage(
    message: string,
    threadId?: string,
    attachedFile?: File
  ): Promise<NovaApiResponse> {
    try {
      console.log("🤖 Nova - Sending message to API:", { message, threadId });

      const requestBody: any = { message };

      // Add thread_id if provided (for context continuation)
      if (threadId) {
        requestBody.thread_id = threadId;
      }

      // Handle file attachment if provided
      if (attachedFile) {
        const formData = new FormData();
        formData.append("message", message);
        if (threadId) {
          formData.append("thread_id", threadId);
        }
        formData.append("file", attachedFile);

        const response = await fetch(this.baseUrl, {
          method: "POST",
          body: formData,
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        console.log("✅ Nova API response:", result);
        return result;
      } else {
        // Text-only message
        const response = await fetch(this.baseUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        console.log("✅ Nova API response:", result);
        return result;
      }
    } catch (error) {
      console.error("❌ Nova API call failed:", error);
      throw error;
    }
  }

  /**
   * Get the current thread ID from the last response
   */
  getThreadIdFromResponse(response: NovaApiResponse): string | null {
    return response.thread_id || null;
  }

  /**
   * Check if the response contains frontend commands
   */
  hasFrontendCommands(response: NovaApiResponse): boolean {
    return !!(
      response.frontend_commands && response.frontend_commands.length > 0
    );
  }

  /**
   * Check if the response contains progress steps
   */
  hasProgressSteps(response: NovaApiResponse): boolean {
    return !!(response.progress_steps && response.progress_steps.length > 0);
  }
}

export const novaApiClient = new NovaApiClient();
export default novaApiClient;
